import {
    EditorContent,
    BubbleMenu,
    FloatingMenu,
    NodeViewContent,
    NodeViewWrapper,
} from "@tiptap/vue-3";

export default defineNuxtPlugin((nuxt) => {
    nuxt.vueApp.component("TiptapEditorContent", EditorContent);
    nuxt.vueApp.component("TiptapBubbleMenu", BubbleMenu);
    nuxt.vueApp.component("TiptapFloatingMenu", FloatingMenu);
    nuxt.vueApp.component("TiptapNodeViewContent", NodeViewContent);
    nuxt.vueApp.component("TiptapNodeViewWrapper", NodeViewWrapper);
});
